import { getDeviceContext } from './track';

/**
 * Builds the v3 skills-framework bot-context for the cult support bot.
 * The cult skill activates purely on the presence of the top-level `cult` key;
 * the backend self-fetches membership from OMS via the JWT identity, so no
 * membership/pricing payload is sent. `platform` follows the shared convention
 * (cashless/reimbursement read it to pick deeplink vs web URLs).
 */
export const buildCultBotContext = () => ({
  platform: getDeviceContext().device_platform,
  cult: {},
});
